import { createI18n } from "vue-i18n";
import nl from "./locales/nl";
import en from "./locales/en";

export const i18n = createI18n({
  legacy: false,
  locale: "nl",
  fallbackLocale: "nl",
  messages: { nl, en },
});
